export default __webpack_public_path__ + "static/media/team38.fd9428aa.JPG";